import buildQuery from '@/helpers/url';
import { HTTP } from '.';
import { store as Store } from '../store';

export const maxQueueLength = 15;
export const maxQueueLengthDisplay = 6;
export const karenMapViewCenter = { lat: -37.8136, lng: 144.9631 };

export default new class RecommendationService {
  constructor() {}

  getRecommendations(leadEventId) {
    return HTTP.get('/v1/lead-event/' + leadEventId + '/recommendations');
  }
  
  sendRecommendation(leadEventId, venues, template, subject, portalLink, sendAsQuickRecommend, doNotSendEmail) {
    console.log({doNotSendEmail});
    return HTTP.post('/v1/lead-event/' + leadEventId + '/recommendations/send', {
      venues,
      template,
      subject,
      portal_link: portalLink,
      send_as_quick_recommend: sendAsQuickRecommend,
      no_email: doNotSendEmail
    });
  }

  getRecommendationPortalLink(leadId, isBeingImpersonated = false) {
    return HTTP.get('/v1/leads/' + leadId + '/recommendations/portal-link?' + buildQuery({'is_being_impersonated': isBeingImpersonated}));
  }

  // Get quick recommendations
	getQuickRecommendations () {
		return HTTP.get(
			'/v1/recommendations/quick-recommendations'
		)
	}
}();
